import { useSelector } from "react-redux";
import { isNullOrUndefined } from "../../../common/utils";

export function useGetUserGroupTypeId(userGroupTypeUniqueName) {
  const userGroupTypes = useSelector((rootState) => {
    return rootState.userGroup.types.value;
  });
  
  for (let userGroupTypeId in userGroupTypes) {
    if (
      !isNullOrUndefined(userGroupTypes[userGroupTypeId]?.uniqueName) &&
      userGroupTypes[userGroupTypeId].uniqueName === userGroupTypeUniqueName
    ) {
      return userGroupTypeId;
    }
  }

  return;
}

export function useGetUserGroupTypes() {
  const userGroupTypes = useSelector((rootState) => {
    return rootState.userGroup.types.value;
  });
  let userGroupTypeArray = []
  for (let userGroupTypeId in userGroupTypes) {
    if (
      !isNullOrUndefined(userGroupTypes[userGroupTypeId])
    ) {
      userGroupTypeArray.push(userGroupTypes[userGroupTypeId])
    }
  }
  return userGroupTypeArray;
}
